import { animate, style, transition, trigger } from '@angular/animations';

export const slideAnimation = trigger('slideAnimation', [
  transition('* => *', [
    style({ transform: '{{from}}' }),
    animate('500ms ease-out', style({ transform: '{{to}}' }))
  ])
]);